
export const API_URL = window.Configs?.API_URL;
export const TUS_URL = window.Configs?.TUS_URL;